import { useQuery } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { api } from '@/api/client';
import { envStyle } from '@/lib/format';
import { Link } from '@/lib/router';

// The names of an environment's sources when none of them has ever sent a line; null when one has (or there is none).
export function useNeverSent(env: string): string[] | null {
    const sources = useQuery({ queryKey: ['sources'], queryFn: api.sources, staleTime: 60_000 });
    const own = (sources.data?.sources ?? []).filter((source) => source.env === env && !source.revoked_at);

    return own.length > 0 && own.every((source) => source.last_seen_at === null) ? own.map((source) => source.name) : null;
}

// An environment whose source is ready but has never sent: what is missing, not an empty range.
export function NeverSent(props: { env: string; names: readonly string[]; panel?: boolean }): ReactNode {
    return (
        <div className={`empty never ${props.panel ? 'panel' : ''}`}>
            <b>{envStyle(props.env).label} has never sent a line</b>
            Its source ({props.names.join(', ')}) is ready: lines arrive once bustard&apos;s {props.env} services have
            <span className="mono"> LOGTAIL_MIRROR_ENDPOINT</span> and <span className="mono">LOGTAIL_MIRROR_RESOURCE_KEY</span> in their Render
            environment group, and deploy.
            <div className="empty-actions">
                <Link className="act primary" to="/sources">
                    See the sources
                </Link>
            </div>
        </div>
    );
}
